// @flow
import ctxToSettingsContextData from './ctxToSettingsContextData';

/**
 * Generates the translation key from the 'product' present in the
 * context in JsonForm and 'path' of the field.
 * @param {*} ctx JsonForm ctx
 * @param {*} path The data path returned from the control props
 * @returns The full transaltion key
 */
const ctxToTranslationKey = (ctx: $FixMe, path: string): string => {
    const { product, toTranslationKey } = ctxToSettingsContextData(ctx);
    const key = path.replaceAll('.', '.fields.');

    return toTranslationKey(product, key);
};

export default ctxToTranslationKey;
